// @ts-nocheck
import { environment } from "@/lib/resources";
import $ from "jquery";

var $productSearch = $(".product-search input[name='q']");

var settings = {
	url: $productSearch.attr("data-quickfinderautosuggest-url"),
	native: $productSearch.attr("data-quickfinderautosuggest-native"),
	alleAnzeigenUrl: $productSearch.closest("form").attr("action"),
};

var $productSearchSuggestions = $("#product-search-suggestions");
var $productSearchAllLink = $("#product-search-all a");
var $productSearchClose = $("#product-search__close");
var $productSearchResponse = $("#product-search-response");

$productSearch.on("keydown", function() {
	clearTimeout($.data(this, "timer"));
	var wait = setTimeout(autoSuggest, 250);
	$(this).data("timer", wait);
});

$productSearchClose.on("click", hideSuggestions);

function autoSuggest() {
	//Die Suche muss aus mindestens zwei Zeichen bestehen
	var q = $productSearch.val();
	if (q.length < 2) {
		hideSuggestions();
		return;
	}

	//Hat sich was an der Eingabe geändert?
	if ($productSearch.data("quickfinder") == q) {
		return;
	}

	$productSearch.data("quickfinder", q);

	var native = settings.native == "true";

	$.ajax({
		url: settings.url,
		cache: false,
		data: {
			native: native,
			q: $productSearch.val()
		},
		success: data => {
			if (data.length > 0) {
				showSuggestions(data);
				return;
			}

			hideSuggestions();
		}
	});
}

function showSuggestions(data) {
	//Alle Anzeigen Url erzeugen
	var alleAnzeigenUrl = settings.alleAnzeigenUrl + "?q=" + encodeURIComponent($productSearch.val());
	$productSearchAllLink.attr("href", alleAnzeigenUrl);

	//bisherige suchergebnisse löschen
	$productSearchResponse.empty();

	//Suchergebnisauflistung erzeugen
	var regExSuche = new RegExp($productSearch.val(), "ig");
	var ersetzung = "<span>" + $productSearch.val() + "</span>";

	// function aus `quickfinder{client}.js`
	var results = getQuickfinderSuggestionsPreview.call($productSearch, data, regExSuche, ersetzung);

	$productSearchResponse.append(results);
	$productSearchSuggestions.addClass("is-visible");
}

function hideSuggestions() {
	$productSearch.data("quickfinder", "");
	$productSearchSuggestions.removeClass("is-visible");

	$productSearchResponse.empty();
}

const getQuickfinderSuggestionsPreview = environment.inocon
	? getQuickfinderSuggestionsPreviewInocon
	: getQuickfinderSuggestionsPreviewGanter;

function getQuickfinderSuggestionsPreviewGanter(data, regExSuche, ersetzung) {
	var ul = $("<ul></ul>");
	$.each(data,
		function() {
			var norm = this.norm.replace(regExSuche, ersetzung);
			var li = $("<li></li>").appendTo(ul);
			var a = $("<a></a>").attr("href", this.url).appendTo(li);
			var divImage = $("<div></div>").addClass("product-search__response__image").appendTo(a);
			$("<img></img>").attr({ src: this.urlHauptbildThumbnail, alt: this.norm }).appendTo(divImage);
			$("<div></div>").addClass("product-search__response__text").html(norm).appendTo(a);
		});

	return ul;
};

function getQuickfinderSuggestionsPreviewInocon(data, regExSuche, ersetzung) {
	var ul = $("<div></div>").attr({ style: "overflow:scroll" });
	$.each(data,
		function() {
			var norm = this.norm.replace(regExSuche, ersetzung);
			var divGridOneCol = $("<div></div>").addClass("grid grid--spacing--1col").appendTo(ul);
			var divGridEntry = $("<div></div>").addClass("grid__entry").appendTo(divGridOneCol);
			var divSearchTeaser = $("<div></div>").addClass("search-teaser").appendTo(divGridEntry);
			var a = $("<a></a>").attr("href", this.url).addClass("teaser-link").appendTo(divSearchTeaser);
			var divTeaserInner = $("<div></div>").addClass("teaser__inner").appendTo(a);
			var divImage = $("<div></div>").addClass("inner__image").appendTo(divTeaserInner);
			$("<img></img>").attr({ src: this.urlHauptbildThumbnail, alt: this.norm }).addClass("lazy img--responsive round-borders").appendTo(divImage);
			$("<div></div>").addClass("inner__title h6").html(norm).appendTo(divTeaserInner);
		});

	return ul;
};
